<template>
  <el-container class="discovery-page">
    <resizable-aside
      :default-width="260"
      :min-width="200"
      :max-width="500"
      storage-key="discovery-aside-width"
    >
      <div class="header">
        <el-input
          class="search-text"
          size="small"
          placeholder="搜索应用"
          v-model="searchText"
        >
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
        <el-button
          plain
          class="add-btn"
          icon="el-icon-plus"
          title="添加应用"
          @click="onAddApp"
        ></el-button>
      </div>
      <el-scrollbar class="app-items">
        <div
          v-for="item in filteredList"
          :key="item.id"
          class="app-item"
          :class="{ active: activeApp.id === item.id }"
          @click="onActiveItem(item)"
        >
          <div class="app-item-avatar">
            <head-image :size="42" :url="item.icon" :name="item.name">
            </head-image>
          </div>
          <div class="app-item-info">
            <div class="app-item-name">{{ item.name }}</div>
          </div>
        </div>
        <div v-if="filteredList.length === 0" class="no-data">暂无应用</div>
      </el-scrollbar>
    </resizable-aside>
    <el-container class="container">
      <div class="header" v-if="activeApp.id">
        <div class="app-name">{{ activeApp.name }}</div>
        <div class="actions">
          <el-button
            type="text"
            icon="el-icon-full-screen"
            @click="openInNewWindow"
            >浏览器打开</el-button
          >
        </div>
      </div>
      <div class="app-content" v-if="activeApp.id">
        <iframe
          v-if="activeApp.linkUrl"
          :src="activeApp.linkUrl"
          frameborder="0"
          class="app-iframe"
        ></iframe>
        <div v-else class="no-link">该应用暂无链接</div>
      </div>
      <div class="empty-state" v-else>
        <div class="empty-tip">
          <i class="el-icon-monitor"></i>
          <p>请在左侧选择应用</p>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import HeadImage from "../components/common/HeadImage.vue";
import ResizableAside from "../components/common/ResizableAside.vue";

export default {
  name: "discovery",
  components: {
    HeadImage,
    ResizableAside,
  },
  data() {
    return {
      searchText: "",
      discoveryList: [],
      activeApp: {},
    };
  },
  computed: {
    filteredList() {
      if (!this.searchText) return this.discoveryList;
      return this.discoveryList.filter((item) =>
        item.name.includes(this.searchText)
      );
    },
  },
  mounted() {
    this.fetchDiscoveryList();
  },
  methods: {
    fetchDiscoveryList() {
      this.$http({
        url: "/discovery/list",
        method: "GET",
      }).then((res) => {
        this.discoveryList = res || [];
      });
    },
    onActiveItem(item) {
      this.activeApp = item;
    },
    onAddApp() {
      this.$message.info("添加应用功能开发中");
    },
    openInNewWindow() {
      if (this.activeApp.linkUrl) {
        window.open(this.activeApp.linkUrl, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.discovery-page {
  height: 100%;
  background: #fff;

  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    .search-text {
      flex: 1;
    }

    .add-btn {
      padding: 8px;
      margin-left: 10px;
      font-size: 16px;
      border-radius: 50%;
      background: var(--im-background-active);
      color: var(--im-color-primary);
      border: none;

      &:hover {
        background: var(--im-background-active-dark);
      }
    }
  }

  .app-items {
    flex: 1;

    .app-item {
      height: 60px;
      display: flex;
      padding: 0 15px;
      align-items: center;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: var(--im-background-active);
      }

      &.active {
        background-color: var(--im-background-active-dark);
      }

      .app-item-avatar {
        margin-right: 12px;
      }

      .app-item-info {
        flex: 1;
        overflow: hidden;

        .app-item-name {
          font-size: 14px;
          color: var(--im-text-color-primary);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: left;
        }
      }
    }

    .no-data {
      padding: 40px 0;
      text-align: center;
      color: #999;
      font-size: 14px;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
    background: #f8f9ff;
    padding: 0;

    .header {
      background: #fff;
      justify-content: space-between;

      .app-name {
        font-size: 18px;
        font-weight: 600;
        color: var(--im-text-color-primary);
      }
    }

    .app-content {
      flex: 1;
      position: relative;
      overflow: hidden;

      .app-iframe {
        width: 100%;
        height: 100%;
        background: #fff;
      }

      .no-link {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #999;
      }
    }

    .empty-state {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fcfdff;

      .empty-tip {
        text-align: center;
        color: #999;

        i {
          font-size: 80px;
          margin-bottom: 20px;
          opacity: 0.3;
        }

        p {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
